export default "/images/daily_practices_sm.jpg?49206f76aea766622caa7aee4ac93db4";